var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecreational(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8936 2.13281C25.5764 2.38665 25.2898 2.69517 25.0471 3.05838L1.43357 38.394C0.0365785 40.4844 0.849524 43.3289 3.14018 44.3655L25.8936 54.6616L25.8936 2.13281ZM30.9829 54.6573L53.7173 44.3784C56.0084 43.3426 56.8222 40.4983 55.4258 38.4074L31.818 3.05931C31.5782 2.70027 31.2956 2.39464 30.9829 2.14242L30.9829 54.6573Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecreational);
export default __webpack_public_path__ + "static/media/Recreational.16e89c51406b845c4afb8e36ba7ade64.svg";
export { ForwardRef as ReactComponent };